import { createMiddleware } from '@tanstack/react-start';

import { canonicalPublicRedirect } from '@/middleware/canonical-public-redirect';

const hstsHeaderValue = 'max-age=31536000; includeSubDomains';

const permanentRedirectStatus = 301;

const withHsts = (response: Response) => {
  response.headers.set('Strict-Transport-Security', hstsHeaderValue);
  return response;
};

export const canonicalRequestMiddleware = createMiddleware().server(
  async ({ request, next, handlerType }) => {
    const isDocumentRequest =
      handlerType === 'router' &&
      (request.method === 'GET' || request.method === 'HEAD');

    if (isDocumentRequest) {
      const location = canonicalPublicRedirect(new URL(request.url));
      if (location) {
        return new Response(null, {
          status: permanentRedirectStatus,
          headers: {
            Location: location,
            'Strict-Transport-Security': hstsHeaderValue,
          },
        });
      }
    }

    const result = await next();
    if (result instanceof Response) {
      return withHsts(result);
    }

    return {
      ...result,
      response: withHsts(result.response),
    };
  },
);
